// Expected error format
//  1. A string
//  2. An object like { errors: { name: ['Can not be blank', 'Must contain letters only'] } }
const formatError = (v) => {
  if (typeof v === 'string') return v.trim();
  return Object.keys(v.errors).map((k) => v.errors[k].map((x) => `${k}: ${x}`.trim()));
};

const errorResponse = (res) =>
  res
    .text()
    .then((v) => {
      try {
        return JSON.parse(v);
      } catch (e) {
        return v;
      }
    })
    .then(formatError)
    .catch(() => `${res.status} ${res.statusText}`.trim());

const okResponse = (v, resolve) => {
  if (v.headers?.has('Location')) {
    window.location.replace(v.headers.get('Location'));
    return null;
  }

  return resolve(v.status === 204 ? true : v.json());
};

// Left pending, like a Location redirect, so no error flashes before the page goes.
const loginResponse = () => {
  window.location.assign('/login');
};

const csrf = () => document.querySelector("meta[name='csrf-token']")?.content;

/** The function requests a data from the server, handles and returns a result.
 * If it is necessary to make a redirect then a response shound have a status that differs from 302 and the Location header to be set:
 *  response.set_header('Location', url)
 *  render json: {}, status: :created
 * A 401 sends the visitor to /login, unless `loginOnUnauthorized: false` - then it rejects like any other error,
 * for a page where the site's login is of no use (e.g. one embedded in the poker client).
 */
export default (url, args = {}, { loginOnUnauthorized = true } = {}) =>
  new Promise((resolve, reject) =>
    window
      .fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf() },
        redirect: 'manual', // causes an error if a statndard 302 redirect has been received
        ...args,
      })
      .then((v) => {
        if (v.ok) {
          okResponse(v, resolve);
        } else if (v.status === 401 && loginOnUnauthorized) {
          loginResponse();
        } else {
          errorResponse(v).then(reject);
        }
      })
  );
